import { useContext } from "react";
import LanguageSelector from "../components/languageSelector/LanguageSelector";
import { translate } from "../config/translator";
import { PspContext } from "../config/contexts";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft } from "@fortawesome/pro-light-svg-icons";
import { useNavigate } from "react-router-dom";
import { useIsTablet } from "@/config/hooks";
import { TopBarMobile } from "@/components/topBarMobile/topBarMobile";

export default function CookiePolicy() {
  const { lang } = useContext(PspContext);
  const isTablet = useIsTablet();

  const navigate = useNavigate();

  return (
    <div className={`${isTablet ? "p-8" : ""} overflow-y-scroll h-screen`}>
      {isTablet ? (
        <>
          <div className="flex flex-row items-center justify-between">
            {/* BACK BUTTON */}
            <button onClick={() => navigate(-1)} className="cursor-pointer m-4">
              <FontAwesomeIcon
                icon={faChevronLeft}
                className="text-3xl text-font-secondary"
              />
            </button>

            {/* LANGUAGE SELECTOR */}
            <div className="w-60">
              <LanguageSelector />
            </div>
          </div>

          {/* PAGE TITLE */}
          <h1 className="font-bold text-3xl my-8">
            {translate("cookiesPageTitle", lang)}
          </h1>
        </>
      ) : (
        <TopBarMobile header="cookiesPageTitle" onBack={() => navigate(-1)} />
      )}

      <div className={isTablet ? "" : "p-6"}>
        {/* PURPOSE */}
        <h2 className="font-bold text-xl mt-4">
          {translate("cookiesPagePurposeTitle", lang)}
        </h2>
        <p>{translate("cookiesPagePurpose", lang)}</p>

        {/* CONTROLLER */}
        <h2 className="font-bold text-xl mt-4">
          {translate("cookiesPageControllerTitle", lang)}
        </h2>
        <p>{translate("cookiesPageController", lang)}</p>

        {/* TECHNOLOGIES */}
        <h2 className="font-bold text-xl mt-4">
          {translate("cookiesPageTechnologiesTitle", lang)}
        </h2>
        <p>{translate("cookiesPageTechnologies", lang)}</p>

        {/* CATEGORIES */}
        <h2 className="font-bold text-xl mt-4">
          {translate("cookiesPageCategoriesTitle", lang)}
        </h2>
        <p>{translate("cookiesPageCategories", lang)}</p>

        {/* CHOICES */}
        <h2 className="font-bold text-xl mt-4">
          {translate("cookiesPageChoicesTitle", lang)}
        </h2>
        <p>{translate("cookiesPageChoices", lang)}</p>

        {/* THIRD PARTIES */}
        <h2 className="font-bold text-xl mt-4">
          {translate("cookiesPageThirdPartiesTitle", lang)}
        </h2>
        <p>{translate("cookiesPageThirdParties", lang)}</p>

        {/* ITEMS */}
        <h2 className="font-bold text-xl mt-4">
          {translate("cookiesPageItemsTitle", lang)}
        </h2>

        {/* ESSENTIAL COOKIES */}
        <div>
          <h3 className="font-bold text-lg mt-4">
            {translate("essentialCookies", lang)}
          </h3>
          <div className="grid grid-flow-row grid-cols-4 gap-px p-px bg-black">
            {/* TABLE HEADER */}
            <p className="break-all bg-white p-4 font-bold">
              {translate("cookieName", lang)}
            </p>
            <p className="break-all bg-white p-4 font-bold">
              {translate("type", lang)}
            </p>
            <p className="break-all bg-white p-4 font-bold">
              {translate("cookiesPagePurposeTitle", lang)}
            </p>
            <p className="break-all bg-white p-4 font-bold">
              {translate("retention", lang)}
            </p>

            {/* ACCESS TOKEN */}
            <p className="break-all bg-white p-4">accessToken</p>
            <p className="break-all bg-white p-4">
              {translate("localStorage", lang)}
            </p>
            <p className="break-all bg-white p-4">
              {translate("accessTokenPurpose", lang)}
            </p>
            <p className="break-all bg-white p-4">
              {translate("untilLogoutClearOrExpiry", lang)}
            </p>

            {/* REFRESH TOKEN */}
            <p className="break-all bg-white p-4">refreshToken</p>
            <p className="break-all bg-white p-4">
              {translate("localStorage", lang)}
            </p>
            <p className="break-all bg-white p-4">
              {translate("refreshTokenPurpose", lang)}
            </p>
            <p className="break-all bg-white p-4">
              {translate("untilLogoutClearOrExpiry", lang)}
            </p>

            {/* COOKIE CONSENT */}
            <p className="break-all bg-white p-4">cookieConsent</p>
            <p className="break-all bg-white p-4">
              {translate("localStorage", lang)}
            </p>
            <p className="break-all bg-white p-4">
              {translate("cookieConsentPurpose", lang)}
            </p>
            <p className="break-all bg-white p-4">
              {translate("untilLogoutOrClear", lang)}
            </p>

            {/* MSAL VERSION */}
            <p className="break-all bg-white p-4">msal.version</p>
            <p className="break-all bg-white p-4">
              {translate("localStorage", lang)}
            </p>
            <p className="break-all bg-white p-4">
              {translate("msalVersionPurpose", lang)}
            </p>
            <p className="break-all bg-white p-4">
              {translate("untilClear", lang)}
            </p>
            {/* SELECTED MANDATE */}

            <p className="break-all bg-white p-4">selectedMandate</p>
            <p className="break-all bg-white p-4">
              {translate("localStorage", lang)}
            </p>
            <p className="break-all bg-white p-4">
              {translate("selectedMandate", lang)}
            </p>
            <p className="break-all bg-white p-4">
              {translate("selectedMandateRetention", lang)}
            </p>
          </div>
        </div>

        {/* FUNCTIONAL COOKIES */}
        <div>
          <h3 className="font-bold text-lg mt-4">
            {translate("functionalCookies", lang)}
          </h3>
          <div className="grid grid-flow-row grid-cols-4 gap-px p-px bg-black">
            {/* TABLE HEADER */}
            <p className="break-all bg-white p-4 font-bold">
              {translate("cookieName", lang)}
            </p>
            <p className="break-all bg-white p-4 font-bold">
              {translate("type", lang)}
            </p>
            <p className="break-all bg-white p-4 font-bold">
              {translate("cookiesPagePurposeTitle", lang)}
            </p>
            <p className="break-all bg-white p-4 font-bold">
              {translate("retention", lang)}
            </p>
          </div>
        </div>

        {/* CONTACT */}
        <h2 className="font-bold text-xl mt-4">
          {translate("cookiesPageContactTitle", lang)}
        </h2>
        <p>{translate("cookiesPageContact", lang)}</p>
      </div>
    </div>
  );
}
